const pageParamWithBaseZero = params => params.page ? params.page - 1 : undefined

const initSearchableSelects = (inputs, extra) => {
  inputs.each(function() {
    const item = $(this)
    var options = $.extend(extra || {}, {})
    var url = item.data('url')
    var field = item.data('field')
    
    $.extend(options, {
      tags: true,
      language: 'it',
      allowClear: true,
      width: '80%',
      ajax: {
        url: url,
        dataType: 'json',
        data: params => {
          return {
            term: params.term,
            page: pageParamWithBaseZero(params),
            field: field
          }
        }
      }
    })

    item.select2(options)
  })
}

// on page ready
$(() => {
  initSearchableSelects($('.metadata-autocomplete-select2'), { placeholder:  '' })
  $('.metadata-select2').select2({ width: '80%' })
})

$(document).on('select2:open', () => {
  document.querySelector(".select2-container--open .select2-search__field").focus()
});
